import React, { useEffect, useMemo, useState } from 'react';
import { PriceUnitStrip, PriceUnitStripContainer } from '../styled';

const DDPriceUnitStrip = (props) => {
  const { productData } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  const varientData = useMemo(() => {
    return (
      productData?.variantOption
        ?.map((variant) => {
          if (variant?.variant_type === 'Pack') {
            return variant?.data?.filter(
              (item) =>
                item?.title !== 'Mini Pack' && item?.title !== 'Travel Pack',
            );
          }
          return [];
        })
        .flat() || []
    );
  }, [productData]);

  const selectedProduct = useMemo(() => {
    return varientData.find((item) => item?.selected == '1');
  }, [varientData]);

  const largerDurationElements = useMemo(() => {
    const selectedDuration = selectedProduct?.repeat_duration || 0;
    return varientData.filter(
      (item) => item?.repeat_duration >= selectedDuration,
    );
  }, [varientData, selectedProduct]);

  useEffect(() => {
    setCurrentIndex(0);
    if (!largerDurationElements || largerDurationElements.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % largerDurationElements.length,
      );
    }, 2500);

    return () => clearInterval(interval);
  }, [largerDurationElements]);

  const currentItem = largerDurationElements?.[currentIndex]?.bottom_strip_data;

  return currentItem ? (
    <PriceUnitStripContainer
      key={currentIndex}
      textBgColor={currentItem?.textBgColor}
      textColor={currentItem?.textColor}
    >
      {currentItem ? (
        <PriceUnitStrip>
          {largerDurationElements?.[currentIndex]?.repeat_duration +
            ' Days Pack '}{' '}
          at{' '}
          <span className="strikeprice">
            {'₹' +
              largerDurationElements?.[currentIndex]?.strikeprice +
              ' '}{' '}
          </span>
          <span className="price">
            {'₹' + largerDurationElements?.[currentIndex]?.price}{' '}
          </span>
        </PriceUnitStrip>
      ) : null}
    </PriceUnitStripContainer>
  ) : null;
};

export default DDPriceUnitStrip;
